/** Shared display labels for case-packet values — one list for every surface
 *  (intake desk, approval detail, history detail), so they cannot drift. */

export const DOC_TYPE_LABELS: Record<string, string> = {
  identity_document: 'ID document',
  medical_report: 'Medical report',
  no_insurance_proof: 'No-insurance proof',
  other: 'Other',
  acceptance_letter: 'Acceptance letter',
};

export const IDENTITY_TYPE_LABELS: Record<string, string> = {
  national_id: 'National ID',
  iqama: 'Iqama',
  passport: 'Passport',
  other: 'Other',
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: 'Cash (self-pay)',
  insurance: 'Insurance',
};
